import { DataBean } from "../DataBean";

export class LoanLinePayrollEntity extends DataBean{


    public async getLoanLinePayrollEntityByLoanLine(idLoanLinePayrollEntity:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getLoanLinePayrollEntityByLoanLine_Number",[idLoanLinePayrollEntity]);
    }
    public async addLoanLineToPayrollEntity(idLoanLine:any,idPayrollEntity:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.loans.LoanLinePayrollEntity_addLoanLineToPayrollEntity_Number_Number", [idLoanLine,idPayrollEntity]);
    }
    // addLoanLineToPayrollEntity

    public async deleteLoanLinePayrollEntity(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteLoanLinePayrollEntity_Number", [bean]);
    }
}